import flatpickr from "flatpickr";
import {Russian} from "flatpickr/dist/l10n/ru.js";
import {sortAll} from "./sortAll";
import {time, timeUpdate} from "./time";
import {subtasks} from "./subtasks";
import {collapse} from "./collapse";
import {projectStatus} from "./projectStatus";
import {Timer} from "./timer/timer";
import {deadline} from "./deadline";
import customSelect from "./customSelect";
import {deleteTask} from "./deleteTask";
import {subscribers} from "./subscribers";
import addFavorite from "./addFavourite";
import {scrollHeader} from "./scroll-header";
import {showSearch, showSearchTab} from "./showSearch";
import {taskSearch} from "./task-search";
import {EditWorkTimeModal} from "./timer/editWorkTimeModal";
import {changeUser} from "./change-user";
import taskEdit from "./task-edit/";
import {changeProject} from "./change-project";
import {AdminTimers} from "./timer/admin-timers";
import showAll from "./showAll";
import {responsibleSearch} from "./responsible-search";
import {report} from "./report";
import {showPassword} from "./show-password";
import togglePanels from "./togglePanels";
import {personalCabinet} from "./personal-cabinet";
import notifications from "./notifications/";
import {copyToClipboard} from "./copyToClipboard";
import {emitter} from "./emitter";
import {addCloseModalsEvents, addOpenModalsEvents} from "./modals";
import {timezone} from "./timezone";
import {QueueChangeTasks} from "./queue-change-tasks";
import {copyUrl} from "./copy-url";
import {taskTools} from "./task-tools";
import {collapseSubtasks} from "./collapse-subtasks";
import tags from "./tags";
flatpickr.localize(Russian);

// НАСТРОЙКИ

try {
  emitter();
  sortAll();
  time();
  timeUpdate();
  deleteTask();
  subtasks();
  scrollHeader();
  projectStatus();
  showSearch();
  showSearchTab();
  deadline(flatpickr);
  collapse({});
  showAll({});

  new QueueChangeTasks().init();

  const timerElement = document.querySelector(`.js-timer-container`) as HTMLElement;

  let timer;
  if (timerElement) {
    timer = new Timer(timerElement);
    timer.init();
    new EditWorkTimeModal(flatpickr, timer).init();
  }

  responsibleSearch();
  // @ts-ignore
  customSelect({openClass: `modal--show`});
  // @ts-ignore
  customSelect({
    selectSelector: `.js-priority-select`,
    openClass: `priority__modal--show`,
    isPrioritySelect: true,
  });
  // @ts-ignore
  customSelect({
    selectSelector: `.js-responsible-select`,
    inputSelector: `.js-responsible-show`,
    openClass: `modal--show`,
    activeItemClass: `modal__item--active`,
    isResponsibleSelect: true,
  });
  // @ts-ignore
  customSelect({
    selectSelector: `.js-report-select`,
    openClass: `modal--show`,
  });
  // @ts-ignore
  customSelect({
    selectSelector: `.js-report-user-select`,
    openClass: `modal--show`,
  });
  // @ts-ignore
  customSelect({
    selectSelector: `.js-report-user-multi-select`,
    openClass: `modal--show`,
    multiselect: true,
  });
  // @ts-ignore
  customSelect({
    selectSelector: `.js-report-period-select`,
    openClass: `modal--show`,
  });
  // @ts-ignore
  customSelect({
    selectSelector: `.js-category-select`,
    openClass: `modal--show`,
    isCategorySelect: true,
  });

  subscribers();

  addFavorite({activeClass: `favourite--pressed`});

  changeUser(timer);

  taskSearch();
  changeProject();
  taskEdit(flatpickr);
  new AdminTimers().init();
  report(flatpickr);
  showPassword();

  togglePanels({
    toggleButtonSelector: `.js-favourite-btn`,
    toggleContainerSelector: `.js-favourite-modal`,
    toggleClass: `favourites--show`,
  });

  togglePanels({
    toggleButtonSelector: `.js-account-btn`,
    toggleContainerSelector: `.js-account-modal`,
    toggleClass: `account--show`,
  });

  personalCabinet();

  addCloseModalsEvents();

  addOpenModalsEvents();

  copyToClipboard();

  notifications();

  timezone();

  copyUrl();

  taskTools();

  collapseSubtasks();

  tags();
} catch (e) {
  // @ts-ignore
  if (window.sendError && !window.location.host.includes(`localhost`) && !window.location.href.includes(`taskroom22v.d-idei.ru/`)) {
    // @ts-ignore
    window.sendError.sendMessage(e);
  }

  console.error(e);
}
